import { useEffect, useRef } from 'react'

import { STORAGE_KEY } from '../constants'
import type { CustomerFormPayload } from '../types'

export function usePersistCustomerPayload(payload: CustomerFormPayload) {
  const firstPersistRef = useRef(true)

  useEffect(() => {
    if (firstPersistRef.current) {
      firstPersistRef.current = false
      return
    }

    try {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(payload))
    } catch {
      // ignore storage failures (private mode, quota, etc.)
    }
  }, [payload])
}
